import { render, staticRenderFns } from "./PsiRowData.vue?vue&type=template&id=e084a284&scoped=true"
import script from "./PsiRowData.vue?vue&type=script&lang=js"
export * from "./PsiRowData.vue?vue&type=script&lang=js"
import style0 from "./PsiRowData.vue?vue&type=style&index=0&id=e084a284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e084a284",
  null
  
)

export default component.exports